<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-holoo-config-1 v-bind='{...{},...{}}' :style='""' class="" ></m-holoo-config-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mHolooConfig1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/Holoo/HolooConfig1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mHolooConfig1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
